import React from "react";

const { Provider, Consumer } = React.createContext(false);

export { Provider, Consumer };
